<h1 mat-dialog-title>Confirmation de suppression</h1>
<div mat-dialog-content>
  <p>Êtes-vous certain de vouloir supprimer ce produit de votre panier ?</p>
</div>
<div mat-dialog-actions class="mt5 mb5 text-center">
  <button type="button" mat-button [mat-dialog-close]="false">ANNULER</button>
  <button type="submit" mat-raised-button color="accent" [mat-dialog-close]="true">OUI</button>
</div>
